import styled from "styled-components";

import { handleTopSpacing } from "helpers/spacingAndFonts";

export const Container = styled.div`
    ${({ topSpacing }) => handleTopSpacing({ topSpacing })}
`;
